import { SVGProps } from 'react'

export const Facebook = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="25" height="24" fill="none" viewBox="0 0 25 24" {...props}>
    <g clipPath="url(#clip0_145_253)">
      <path
        fill="#05155E"
        d="M12.5 0C5.872 0 .5 5.373.5 12c0 5.628 3.874 10.35 9.101 11.647v-7.98H7.127V12H9.6v-1.58c0-4.084 1.848-5.978 5.858-5.978.76 0 2.073.15 2.61.298v3.324c-.284-.03-.776-.044-1.387-.044-1.967 0-2.728.745-2.728 2.683V12h3.92l-.674 3.667h-3.246v8.245C19.896 23.195 24.5 18.135 24.5 12c0-6.627-5.373-12-12-12z"
      ></path>
    </g>
    <defs>
      <clipPath id="clip0_145_253">
        <path fill="#fff" d="M0 0H24V24H0z" transform="translate(.5)"></path>
      </clipPath>
    </defs>
  </svg>
)
